import { t } from "../../../../utils/i18n";
import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import toastr from "toastr";
import { required } from "../../../../utils/formValidations";
import { postRequest } from "../../../../utils/httpRequest";
import "./index.scss";

interface Props {
  cardRequest: {
    id: string;
    country_code: string;
  };
}

interface State {
  submitting: boolean;
  isLoading: boolean;
  apiErrors?: any;
}

class GetCard extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      isLoading: false,
      apiErrors: {},
    };
  }

  submit = (values) => {
    const { cardRequest } = this.props;
    this.setState({ submitting: true });

    postRequest(
      `/api/v1/cards/requests/${cardRequest.id}/create_rain_card`,
      {},
      {
        "Content-Type": "application/json",
      }
    )
      .then((response) => {
        window.location.href = `/cards/details/${response.id}`;
      })
      .catch((error) => {
        console.log(error);
        this.setState({ submitting: false });

        console.log("error", error);

        toastr.error(
          error?.error || error?.data?.error || t("cards.common.something_went_wrong")
        );
      });
  };

  render() {
    const { cardRequest } = this.props;

    const { submitting } = this.state;

    return (
      <div className="w-100">
        <div className="create-offer-title"></div>
        <Formik
          initialValues={{
            e_consent_accepted: false,
            account_opening_accepted: false,
            terms_accepted: false,
            correct_info_accepted: false,
            unauthorized_solicitation_accepted: false,
          }}
          onSubmit={(values) => this.submit(values)}
        >
          {({ setFieldValue, errors, values, handleChange, validateForm }) => (
            <Form className="form mt-5">
              <div className="row card-deck mb-5 request-right-col">
                <form className="col-md-12">
                  <div className="">
                    <div className="form-check">
                      <Field
                        type="checkbox"
                        name="e_consent_accepted"
                        className="form-check-input"
                        placeholder={t("cards.request_form.e_g_10_000")}
                        validate={required}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="terms_accepted"
                      >
                        {t("cards.request_form.i_accept_the")}{" "}
                        <a
                          href="https://www.bananacrystal.com/docs/electronic-sign/"
                          target="_blank"
                        >
                          {t("cards.request_form.e_sign_consent")}
                        </a>
                      </label>
                      {errors.e_consent_accepted && (
                        <small className="error" style={{ display: "block" }}>
                          {errors.e_consent_accepted}
                        </small>
                      )}
                    </div>
                    {cardRequest.country_code === "US" && (
                      <>
                        <br />
                        <div className="form-check">
                          <Field
                            type="checkbox"
                            name="account_opening_accepted"
                            className="form-check-input"
                            placeholder={t("cards.request_form.e_g_10_000")}
                            validate={required}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="terms_accepted"
                          >
                            {t("cards.request_form.i_accept_the")}{" "}
                            <a
                              href="https://www.bananacrystal.com/docs/virtual-card-account-opening"
                              target="_blank"
                            >
                              {t("cards.request_form.account_opening_privacy_notice")}
                            </a>
                          </label>
                          {errors.account_opening_accepted && (
                            <small
                              className="error"
                              style={{ display: "block" }}
                            >
                              {errors.account_opening_accepted}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    <br />
                    <div className="form-check">
                      <Field
                        type="checkbox"
                        name="terms_accepted"
                        className="form-check-input"
                        placeholder={t("cards.request_form.e_g_10_000")}
                        validate={required}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="terms_accepted"
                      >
                        {t("cards.request_form.i_accept_the")}{" "}
                        <a
                          href="https://www.bananacrystal.com/docs/bananacrystal-spend-card-terms/"
                          target="_blank"
                        >
                          {t("cards.request_form.card_terms")}{" "}
                        </a>
                        {t("cards.request_form.and_the")}{" "}
                        <a
                          href="https://www.third-national.com/privacypolicy"
                          target="_blank"
                        >
                          {t("cards.request_form.issuer_privacy_policy")}
                        </a>
                      </label>
                      {errors.terms_accepted && (
                        <small className="error" style={{ display: "block" }}>
                          {errors.terms_accepted}
                        </small>
                      )}
                    </div>
                    <br />
                    <div className="form-check">
                      <Field
                        type="checkbox"
                        name="correct_info_accepted"
                        className="form-check-input"
                        placeholder={t("cards.request_form.e_g_10_000")}
                        validate={required}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="terms_accepted"
                      >
                        {t("cards.request_form.i_certify_that_the_information_i")}
                      </label>
                      {errors.correct_info_accepted && (
                        <small className="error" style={{ display: "block" }}>
                          {errors.correct_info_accepted}
                        </small>
                      )}
                    </div>
                    <br />
                    <div className="form-check">
                      <Field
                        type="checkbox"
                        name="unauthorized_solicitation_accepted"
                        className="form-check-input"
                        placeholder={t("cards.request_form.e_g_10_000")}
                        validate={required}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="terms_accepted"
                      >
                        {t("cards.request_form.i_acknowledge_that_applying_for_the")}
                      </label>
                      {errors.unauthorized_solicitation_accepted && (
                        <small className="error" style={{ display: "block" }}>
                          {errors.unauthorized_solicitation_accepted}
                        </small>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              <div className="p-3">
                <div className="d-flex flex-row justify-content-between">
                  <button
                    type="submit"
                    className="btn btn-purple  float-right"
                    disabled={submitting}
                  >
                    {submitting && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {t("cards.request_form.get_my_card")} <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default GetCard;
